/*
*
* File JS per la Single Charter Destinations
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import heroSingle from 'components/heroes/hero-single';
import blockTitle from 'components/block-title/block-title';
import blockText from 'components/block-text/block-text';
import blockCol2 from 'components/block-col2/block-col2';
import blockQuote from 'components/block-quote/block-quote';
import sliderListYacht from 'components/yacht/slider-list-yacht';
import cardYacht from 'components/yacht/card-yatch';

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import './single-charter-destinations.scss';

//--------------------------------------------------------------------//


// INIT COMPONENTI
//--------------------------------------------------------------------//

window.addEventListener('DOMContentLoaded', (e) =>
{
    blockCol2();
    sliderListYacht();
});

//--------------------------------------------------------------------//